export default __webpack_public_path__ + "static/media/480_store05-fr-mobile.4e2bbd4b.png";